import React, { Component } from 'react'
import './InputForm.css'

export default class InputForm extends Component {
  render() {
    const {id, onBlur, input_required, input_type, input_value, with_label_text, label_text, label_htmlFor, with_small_text, small_text, input_id, input_placeholder, onChange} = this.props
    return (
    <div id={id} className="InputForm form-group">
        {with_label_text===true?
        <label htmlFor={ label_htmlFor }>{ label_text }</label>
        :null}

        <input onBlur={onBlur!==undefined?onBlur:null} required={input_required} value={input_value} onChange={onChange} type={ input_type } className="form-control" id={ input_id } aria-describedby={ input_id }  placeholder={ input_placeholder }/>
        
        {with_small_text===true?
        <small id={ input_id }  className="form-text text-muted">{ small_text } </small>
        :null}
    </div>
    )
  }
}
